export default "__VITE_ASSET__DWPxeVPu__"